export default "__VITE_ASSET__5tP4fxBN__"